<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>PCS 03 API Response</h1>
      <b-row>
        <b-col md="3">
          <label>Interface Name</label>
          <b-form-input
            :formatter="capitalizeAll"
            disabled
            id="interfaceName"
            name="interfaceName"
            v-model="interfaceName"
          ></b-form-input
        ></b-col>
        <b-col md="3">
          <label>SB Number (7005705)</label>
          <b-form-input
            :formatter="capitalizeAll"
            id="sbNumber"
            name="sbNumber"
            v-model="sbNumber"
          ></b-form-input
        ></b-col>
        <b-col md="3">
          <b-button
            v-if="interfaceName && sbNumber"
            @click="getAllPCS03Func()"
            size="sm"
            variant="info"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
            >Fetch</b-button
          >
        </b-col>
      </b-row>
      <hr />
      <div v-if="!getAllPcs03 || getAllPcs03.responseMsg !== 'SUCCESS'">
        <b class="text-danger">No data found.</b>
      </div>
      <div v-else>
        <b-row>
          <b-col md="3" class="mt-1 mb-1">
            <strong class="text-success"
              >Response Status: {{ getAllPcs03.responseMsg }}</strong
            >
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>LEO Date:</strong>
            {{ getAllPcs03.leoDate }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Rotation Date:</strong>
            {{ getAllPcs03.rotationDate }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Nature of Cargo:</strong>
            {{ getAllPcs03.natureOfCargo }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Rotation No:</strong>
            {{ getAllPcs03.rotationNo }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>SB Number:</strong>
            {{ getAllPcs03.sbNumber }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>SB Date:</strong>
            {{ getAllPcs03.sbDate }}
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection.js";
export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllPCS03Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      interfaceName: "CHPOE07",
      sbNumber: "",
      getAllPcs03: null,
      isLoading: false,
      error: false,
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() {},

  beforeDestroy() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  methods: {
    async getAllPCS03Func() {
      let payload = {};
      this.isLoading = true;
      this.getAllPcs03 = null;

      if (this.interfaceName && this.sbNumber) {
        payload = {
          itemCode: "PCS03",
          funcUrl: "PCS/03",
          interfaceName: this.interfaceName,
          sbNumber: this.sbNumber,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (
                data.getAllPcs03.response.response &&
                data.getAllPcs03.response.response.length > 0
              ) {
                this.getAllPcs03 = data.getAllPcs03.response.response[0].response[0];
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log("Catch on getAllPcs03 Error: ", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// PCS03_ResponseDisplay.vue?3f9dfc74